import React, { useEffect } from 'react'

import Cookies from 'js-cookie'

import usePromo from 'artkive/hooks/usePromo'
import { COOKIE_KEYS, onKlaviyoForms } from 'artkive/utils/klaviyoHelpers'

const withKlaviyoFormCatch = (Component) => {
  const WithKlaviyoFormCatchWrapper = (props) => {
    const { dispatchPromo, promoCode: promoFromStore } = usePromo({})

    useEffect(() => {
      const savedPromoCode = Cookies.get(COOKIE_KEYS.KLAVIYO_PROMO_CODE)
      if (!savedPromoCode || !!promoFromStore) return
      dispatchPromo({ promoCode: savedPromoCode })
    }, [dispatchPromo, promoFromStore])

    useEffect(() => {
      const handleKlaviyoForm = async (e) => {
        const formValues = await onKlaviyoForms(e)
        dispatchPromo({ ...formValues })
      }
      window.addEventListener('klaviyoForms', handleKlaviyoForm)

      return () => window.removeEventListener('klaviyoForms', handleKlaviyoForm)
    }, [dispatchPromo])

    return <Component {...props} />
  }

  return WithKlaviyoFormCatchWrapper
}

export default withKlaviyoFormCatch
